export default {
  title: "",
  subtitle: "",
  path: "bank_account_update",
  paragraph: "And for updating any information regarding a bank account, you will use the following endpoint:",
  request: {
    method: "PUT", 
    endpoint: "/subject/:id/bank_accounts/:bank_account_id",
    payload: {
      "bank_account": {
        "account_number": "32924070",
        "branch_number": "0044",
        "owner_document_number": "12345678901",
        "owner_name": "Account owner name",
        "branch_country": "BR",
        "bank": {
          "code": "131",
          "name": "Caixa Econômica Municipal"
        },
        "currency": "BRL",
      }
    },
    responses: {
      "data": {
        "routing_number": null,
        "owner_name": "Mauricio Silva",
        "owner_document_number": "24189952087",
        "pix_info": null,
        "owner_company": {
          "social_name": "Mauricio Silva",
          "id": "0be2c99a-bb6e-4a1f-97a5-5eeaff0671c8",
          "document_type": "cpf",
          "document_number": "24189952087"
        },
        "nickname": null,
        "intermediary_bank_account_id": null,
        "id": "3e217a9d-bfc7-48bc-b436-304f3edbd82f",
        "iban": null,
        "currency": "BRL",
        "branch_number": "134",
        "branch_country": "BRA",
        "pix_info": null,
        "nickname": null,
        "bank": {
          "swift": "BBDEBRSP",
          "country": "BRA",
          "ispb": null,
          "name": "Banco Bradesco S.A.",
          "id": "618804fc-bc62-4754-bf24-651df9a098b3",
          "code": "237"
        },
        "account_type": "conta-corrente",
        "account_number": "1350056",
        "aba": null
      }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Customer UUID"
    },
    {
      name: "bank_account_id",
      type: "string",
      required: true,
      description: "Bank account UUID"
    }
  ],
  parameterPayload: [
    {
      name: "bank_account",
      type: "array ",
      required: false,
      description: "An array of objects containing, each one:",
      is_parent: true
    },
    {
      name: "bank_account.account_number",
      type: "string",
      required: false,
      description: "Account number",
    },
    {
      name: "bank_account.branch_number",
      type: "string",
      required: false,
      description: "Account branch number",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: false,
      description: "Account owner document number CPF/CNPJ",
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: false,
      description: "Account owner full name",
    },
    {
      name: "bank_account.branch_country",
      type: "String",
      required: false,
      description: "An ISO 3166-1 alpha-2 country code of the account coutry",
    },
    {
      name: "bank_account.currency",
      type: "string",
      required: false,
      description: "Account currency (ISO 4217 format)",
    },
    {
      name: "bank",
      type: "object",
      required: false,
      description: "An object containing:",
      is_parent: false
    },
    {
      name: "bank.code",
      type: "string",
      required: false,
      description: "Bank code in Brazil (3 digits)",
    },
    {
      name: "bank.name",
      type: "string",
      required: false,
      description: "Bank name²",
    },
  ],
  footerNotes: 'If a previously registered bank code is provided, its id and name will be loaded from the database.',
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'If you try to update a pix info in a non BRL account',
        code: {
            "errors": {
                "pix_info": [
                    "must be used on Brazilian accounts only"
                ]
            }
        },
        solution: 'Change to a BRL account'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/CustomerUpdateBankAccount.js